


































































import { defineComponent } from "@vue/composition-api"
import { useInputRules } from "@/ts/functions/composition/inputRules";

export default defineComponent({

  name : "ContactInfosInput",

  props: {
    value: {
      type:Object,
      default:{}
    },
    loading: {
      type:Boolean,
      default:false
    }
  },

  setup(props, {emit}) {

    const rules = useInputRules();

    const facebookChange = (value:Object) => {
      var infos = {... props.value}
      infos.facebook = value
      emit("input", infos);
    }

    const instagramChange = (value:Object) => {
      var infos = {... props.value}
      infos.instagram = value
      emit("input", infos);
    }

    const youtubeChange = (value:Object) => {
      var infos = {... props.value}
      infos.youtube = value
      emit("input", infos);
    }

    const emailChange = (value:Object) => {
      var infos = {... props.value}
      infos.email = value
      emit("input", infos);
    }

    return{
      rules,
      facebookChange,
      instagramChange,
      youtubeChange,
      emailChange
    }

  }
});
